import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/*
  Generated class for the BrowserBackService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BrowserBackService {

  private eventSource = new Subject<any>();
  event$ = this.eventSource.asObservable();

  isBack:boolean = true;

  constructor(public http: HttpClient) {
    console.log('Hello BrowserBackService Provider');
  }

  trigger() {
    if (this.isBack) return true;
    history.pushState(null, null, null);
    this.eventSource.next();
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/providers/browser-back-service/browser-back-service.ts